<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">Technical</h3>
		</header>
		<div class="card-body">
			<section>
				<div class="form-group">
					<label>Tier</label>
					<select3 :value.sync="commercialTechnical.tier" :data="tiers" :config="selectConfig"></select3>
				</div>
				<div class="form-group">
					<label>Affiliate Tag</label>
					<select3 :value.sync="commercialTechnical.affiliate_tag" :data="commercialTechnical.affiliateTags" :config="affiliateSelectConfig" :add-new="true"></select3>
				</div>
			</section>
			<section>
				<h4 class="card-subtitle">Additional Options</h4>
				<label class="label-checkbox" for="popup">
					<input id="popup" name="popup" type="checkbox" v-model="commercialTechnical.popup">
					Disable Pop-Up
				</label>
				<label class="label-checkbox" for="alternatives-popup">
					<input id="alternatives-popup" name="alternatives-popup" type="checkbox" v-model="commercialTechnical.alternatives_popup">
					Disable Alternatives Pop-up
				</label>
				<label class="label-checkbox" for="banner">
					<input id="banner" name="banner" type="checkbox" v-model="commercialTechnical.banner" disabled>
					Enable Banner (now disabled)
				</label>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		commercialTechnical: {
			required: true
		}
	},
	data() {
		return {
			tiers: [
				{
					'id': 'tier1',
					'value': 'Tier 1'
				},
				{
					'id': 'tier2',
					'value': 'Tier 2'
				},
				{
					'id': 'tier3',
					'value': 'Tier 3'
				},
				{
					'id': 'tier4',
					'value': 'Tier 4'
				}
			],
			selectConfig: {
				keyName: 'id',
				valueName: 'value'
			},
			affiliateSelectConfig: {
				keyName: 'label',
				valueName: 'value'
			}
		}
	}
}
</script>

<style scoped>

</style>
